import request from './index'
// 获取酒店信息
export function getWebSite(data) {
    return request({
      url: '/api/Order/GetWebSite',
      method: 'post',
      data
    })
  }
  //客房列表
  export function orderListSearch(data) {
    return request({
      url: '/api/Order/OrderListSearch',
      method: 'post',
      data
    })
  }
  //预订酒店详情
  export function orderSubmitDetail(data) {
    return request({
      url: '/api/Order/OrderSubmitDetail',
      method: 'post',
      data
    })
  }
//   微信支付
export function orderSubmit(token,data) {
    return request({
      url: '/api/Order/OrderSubmit',
      method: 'post',
      headers: {'Token': token},
      data
    })
  }
// 查询我的预定
export function getMemberOrderList(token,data) {
  return request({
    url: '/api/Order/GetMemberOrderList',
    method: 'post',
    headers: {'Token': token},
    data
  })
}

// 查询订单是否支付完成
export function getOrderInfo(token,data) {
  return request({
    url: '/api/Order/GetOrderInfo',
    method: 'post',
    headers: {'Token': token},
    data
  })
}

